import {type IAssetProjectReview} from '../schema';

export const canViewAssetProjectReview = (review?: IAssetProjectReview) => true;
